module.exports = __webpack_public_path__ + "3e03caab8309472c26e77959427abe62.svg";